import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import { forwardRef } from 'react';
import defaultStyles from './styles/Field.module.scss.js';
import { jsxs } from 'react/jsx-runtime';

const Field = /*#__PURE__*/forwardRef(({
  theme,
  label,
  input,
  hint,
  message,
  dataTestId
}, ref) => {
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  return /*#__PURE__*/jsxs("div", {
    className: styles.field,
    ref: ref,
    "data-test-id": dataTestId,
    children: [label, hint ? /*#__PURE__*/jsxs("div", {
      className: styles.control,
      children: [input, hint]
    }) : input, message]
  });
});

export { Field };
